import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from "@mui/material";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { getConvocatoriaContext, contextErrorMessage } from "../utils/convocatoriaContext";

export async function getNutriContext(id) {
  return getConvocatoriaContext(id);
}

export default function NutriCaptureControls({ capture, role, canWrite, onContext }) {
  const [open, setOpen] = useState(false);
  const [uuid, setUuid] = useState("");
  const [contextError, setContextError] = useState("");
  useEffect(() => {
    let cancelled = false;
    onContext(null);
    setContextError("");
    if (capture.contextReady && capture.qa.enabled) {
      getNutriContext(capture.convocatoriaId).then(value => {
        if (!cancelled) onContext(value);
      }).catch(error => {
        if (!cancelled) setContextError(contextErrorMessage(error));
      });
    }
    return () => { cancelled = true; };
  }, [capture.convocatoriaId, capture.contextReady, capture.qa.enabled, onContext]);
  const recover = async id => { await capture.open(id); };
  return <Box sx={{ mt: 1 }}>
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
      {!capture.contextReady ? <>
        <TextField size="small" label="Convocatoria" value={capture.convocatoriaId}
          disabled={capture.busy || capture.dirty || capture.uncertain || Boolean(capture.record)}
          onChange={event => capture.changeContext(event.target.value)} inputProps={{ inputMode: "numeric" }} sx={{ width: 180 }} />
        <Button disabled={capture.busy || !capture.qa.enabled} onClick={() => capture.loadList()}>Abrir convocatoria</Button>
      </> : <Typography variant="body2">Convocatoria {capture.convocatoriaId}</Typography>}
      <Button startIcon={<FolderOpenOutlinedIcon />} onClick={() => { setOpen(true); if (capture.contextReady) capture.loadList(); }} disabled={capture.busy || capture.uncertain}>Atenciones</Button>
      {["1", "2", "6", "11"].includes(String(role)) && capture.record &&
        <Button startIcon={<AddOutlinedIcon />} onClick={capture.newCapture} disabled={capture.busy || capture.uncertain}>Nueva atención</Button>}
      {["8", "9", "10"].includes(String(role)) && capture.record &&
        <Button onClick={capture.newCapture} disabled={capture.busy}>Cerrar atención</Button>}
    </Box>
    {!capture.qa.enabled && <Alert severity="warning" sx={{ mt: 1 }}>{capture.qa.reason}</Alert>}
    {contextError && <Alert severity="warning" sx={{ mt: 1 }}>{contextError}</Alert>}
    {!canWrite && role && <Alert severity="info" sx={{ mt: 1 }}>Consulta únicamente para este registro.</Alert>}
    {capture.notice && <Alert severity={capture.notice.severity} sx={{ mt: 1, py: 0 }}>{capture.notice.text}</Alert>}
    {capture.conflict && capture.record && <Button onClick={() => capture.open(capture.record.id)}>Recuperar versión actual</Button>}
    {capture.uncertain && <Alert severity="warning" action={<Button onClick={capture.retry} disabled={capture.busy}>Reintentar guardado</Button>}>
      No se pudo confirmar el guardado. Los cambios se conservan.
    </Alert>}
    <Dialog open={open} onClose={() => !capture.busy && setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Atenciones</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap" }}>
          <TextField size="small" label="UUID de atención" value={uuid} onChange={event => setUuid(event.target.value)} sx={{ flex: 1, minWidth: 180 }} />
          <Button onClick={() => recover(uuid)} disabled={capture.busy || capture.uncertain}>Recuperar atención</Button>
          <TextField select size="small" label="Estado" value={capture.statusFilter} onChange={event => capture.setStatusFilter(event.target.value)} sx={{ width: 160 }}>
            <MenuItem value="">Todos</MenuItem><MenuItem value="0">Pendiente</MenuItem><MenuItem value="1">Verificado</MenuItem><MenuItem value="3">Error</MenuItem>
          </TextField>
          <Button onClick={() => capture.loadList()} disabled={capture.busy}>Actualizar</Button>
        </Box>
        {capture.record && <Typography variant="body2" sx={{ my: 1 }}>{capture.record.id} · versión {capture.record.version} · {capture.record.estatus?.key}</Typography>}
        {capture.notice?.severity === "error" && <Alert severity="error" sx={{ mt: 1 }}>{capture.notice.text}</Alert>}
        {capture.list.map(item => <Box key={item.id} sx={{ display: "flex", alignItems: "center", gap: 1, borderBottom: "1px solid", borderColor: "divider", py: 1 }}>
          <Typography variant="body2" sx={{ flex: 1, minWidth: 0, overflowWrap: "anywhere" }}>{item.id} · {item.estatus?.key}</Typography>
          <Button onClick={() => recover(item.id)} disabled={capture.busy || capture.uncertain}>Abrir</Button>
        </Box>)}
        {capture.nextCursor && <Button onClick={() => capture.loadList(true)} disabled={capture.busy}>Cargar más</Button>}
      </DialogContent>
      <DialogActions><Button onClick={() => setOpen(false)} disabled={capture.busy}>Cerrar</Button></DialogActions>
    </Dialog>
  </Box>;
}
